export default Buffer.from("AuBSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TRQEBAACBh39xRAAAgX8AgX+CAIF/hACBf4YAgX+IAIF/igCBf4wAgX+OAIF/kACBf5IAgX+UAIF/lgCBf5gAgX+aAIF/nACBf54AgX+gAIF/ogCBf6QAgX+mAIF/qACBf6oAgX+sAIF/rgCBf7AAgX+yAIF/tACBf7YAgX+4AIF/ugCBf7wAgX++AIF/wACBf8IAgX/EAIF/xgCBf8gAgX/KAIF/zACBf84AgX/QAIF/0gCBf9QAgX/WAIF/2ACBf9oAgX/cAIF/3gCBf+AAgX/iAIF/5ACBf+YAgX/oAIF/6gCBf+wAgX/uAIF/8ACBf/IAgX/0AIF/9gCBf/gAgX/6AIF//ACBf/4AgX+BgACBf4GCAIF/gYQAgX+BhgA=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/Adobe-CNS1-1.bcmap
// module id = 587
// module chunks = 502